const stripeAmountToChfs = (amount?: number) => {
  return amount ? amount / 100 : undefined;
};

const chfsToStripeAmount = (amount?: number) => {
  return amount ? amount * 100 : undefined;
};

export { stripeAmountToChfs, chfsToStripeAmount };